import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { Validators } from 'ngx-editor';
import { QuillModules } from 'ngx-quill';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';
import { UniversityService } from 'src/app/core/services/university/university.service';

@Component({
    selector: 'app-common-form',
    templateUrl: './common-form.component.html',
    styleUrls: ['./common-form.component.scss'],
})
export class CommonFormComponent implements OnInit {
    @Input() interviewForm: FormGroup | any = new FormGroup({});
    @Input() showOnlyTemplate: boolean = false;
    @Input() questions: any = null;
    @Input() uniName: any = null;
    @Output() formSubmit: EventEmitter<any> = new EventEmitter<any>();

    QuillModules: QuillModules = {
        toolbar: [
            // default value
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
            [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
            [{ direction: 'rtl' }], // text direction
            [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],
            ['clean'], // remove formatting button
            ['link', 'image', 'video'], // link and image, video
        ],
    };

    radioQuestionArr: any =[];

    decisionQuestionArr: any = [
        {
            primary: {
                heading: 'Decision',
                label: 'Decision Questions',
                categoryName: 'Decision',
            },
            questions: [
                {
                    type: 'radio',
                    labelName: 'Decision Questions',
                    categoryName: 'Decision',
                    isRequired: true,
                    question: 'Have you understood all the questions?',
                    options: [
                        {
                            id: 'all_ans1',
                            name: 'all_ans',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'all_ans2',
                            name: 'all_ans',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
                {
                    labelName: 'Decision Questions',
                    categoryName: 'Decision',
                    type: 'radio',
                    isRequired: true,
                    question: 'Is there anything else you wish to add?',
                    options: [
                        {
                            id: 'anything_else1',
                            name: 'anything_else',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'anything_else2',
                            name: 'anything_else',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },

                {
                    labelName: 'Decision Questions',
                    categoryName: 'Decision',
                    type: 'radio',
                    isRequired: true,
                    question:
                        'Are you happy with the conduct of the interview?',
                    options: [
                        {
                            id: 'int_happy1',
                            name: 'int_happy',
                            value: 'Answered',
                            label: 'Answered',
                        },
                        {
                            id: 'int_happy2',
                            name: 'int_happy',
                            value: 'Not Answered',
                            label: 'Not Answered',
                        },
                    ],
                },
            ],
        },
    ];

    interviewQuestions: any = [
        {
            primary: {
                heading: 'Interview Questions',
                label: 'Compulsory Questions',
                categoryName: 'Compulsory',
                options: [
                    {
                        id: 'prepared',
                        name: 'r1',
                        value: 'Prepared',
                        label: 'Prepared',
                    },
                    {
                        id: 'not_prepared',
                        name: 'r1',
                        value: 'Not Prepared',
                        label: 'Not Prepared',
                    },

                    {
                        id: 'needto_prepare',
                        name: 'r1',
                        value: 'Need to Prepare',
                        label: 'Need to Prepare',
                    },
                    {
                        id: 'na',
                        name: 'r1',
                        value: 'NA',
                        label: 'NA',
                    },
                ],
            },

            questionList: [
                {
                    labelName: 'Compulsory Questions',
                    categoryName: 'Compulsory',
                    question:
                        '1. Which University and course have you applied? And what is your course duration?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Compulsory Questions',
                    categoryName: 'Compulsory',
                    question:
                        '2. Are you married? Do you have kids? Will they travel as dependent with you',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Compulsory Questions',
                    categoryName: 'Compulsory',
                    question:
                        '3. Do you have a previous visa refusal from UK or any other country? If yes what was the visa category and reason of refusal?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Compulsory Questions',
                    categoryName: 'Compulsory',
                    question:
                        '4. Which other university you have applied? Why this University?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Compulsory Questions',
                    categoryName: 'Compulsory',
                    question:
                        '5. What are your plans after completion of course?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Compulsory Questions',
                    categoryName: 'Compulsory',
                    question:
                        '6. How will this course help you with your future plan?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Compulsory Questions',
                    categoryName: 'Compulsory',
                    question:
                        '7. This course was available in India as well, so why not India?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Compulsory Questions',
                    categoryName: 'Compulsory',
                    question:
                        '8. Why do you want to study in UK and why not any other country?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Compulsory Questions',
                    categoryName: 'Compulsory',
                    question:
                        '9. What was your previous qualification and when was it completed?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Compulsory Questions',
                    categoryName: 'Compulsory',
                    question:
                        '10. What were you doing after completion of your last qualification till date?',
                    answerType: 'textarea',
                },
            ],
        },
    ];

    livingExpenseQuestions: any = [
        {
            primary: {
                heading: 'University and Living-Expense Questions',
                categoryName: 'University Living',
                options: [
                    {
                        id: 'prepared',
                        name: 'r1',
                        value: 'Prepared',
                        label: 'Prepared',
                    },
                    {
                        id: 'not_prepared',
                        name: 'r1',
                        value: 'Not Prepared',
                        label: 'Not Prepared',
                    },

                    {
                        id: 'needto_prepare',
                        name: 'r1',
                        value: 'Need to Prepare',
                        label: 'Need to Prepare',
                    },
                    {
                        id: 'na',
                        name: 'r1',
                        value: 'NA',
                        label: 'NA',
                    },
                ],
            },

            questionList: [
                {
                    labelName: 'University Living Questions',
                    categoryName: 'University Living',
                    question: '11. Where is University located?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'University Living Questions',
                    categoryName: 'University Living',
                    question:
                        '12. Where will you stay in the UK during your studies ?How much will it cost?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'University Living Questions',
                    categoryName: 'University Living',
                    question:
                        '13. How will you travel to the university each day and how much will this cost?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'University Living Questions',
                    categoryName: 'University Living',
                    question:
                        '14. Have you previously studied in UK? If yes what are the details and was there overstay of visa or deported for any reason.',
                    answerType: 'textarea',
                },
                {
                    labelName: 'University Living Questions',
                    categoryName: 'University Living',
                    question:
                        '15. Provide details about two or three specific modules from the course you have chosen and name all course modules.',
                    answerType: 'textarea',
                },
                {
                    labelName: 'University Living Questions',
                    categoryName: 'University Living',
                    question:
                        '16. How is the course assessed and how many hours of study a day or per week',
                    answerType: 'textarea',
                },
                {
                    labelName: 'University Living Questions',
                    categoryName: 'University Living',
                    question: '17. What is your Tuition fee',
                    answerType: 'textarea',
                },
                {
                    labelName: 'University Living Questions',
                    categoryName: 'University Living',
                    question: '18. What will be your living Expence',
                    answerType: 'textarea',
                },
                {
                    labelName: 'University Living Questions',
                    categoryName: 'University Living',
                    question:
                        '19. What is the University ranking in UK and World? Please provide source of infromation on this details.',
                    answerType: 'textarea',
                },
                {
                    labelName: 'University Living Questions',
                    categoryName: 'University Living',
                    question:
                        '20. If you intend to work in the UK, do you know how many hours you are allowed to work(HC)',
                    answerType: 'textarea',
                },
                {
                    labelName: 'University Living Questions',
                    categoryName: 'University Living',
                    question:
                        '21. Do you have relatives who have studied at a similar level or have studied overseas',
                    answerType: 'textarea',
                },
                {
                    labelName: 'University Living Questions',
                    categoryName: 'University Living',
                    question:
                        '22. Do you plan to do part time jobs in UK and stay back',
                    answerType: 'textarea',
                },
            ],
        },
    ];

    additionalQuestions: any = [
        {
            primary: {
                heading: 'Additional Questions',
                categoryName: 'Additional',
                options: [
                    {
                        id: 'prepared',
                        name: 'r1',
                        value: 'Prepared',
                        label: 'Prepared',
                    },
                    {
                        id: 'not_prepared',
                        name: 'r1',
                        value: 'Not Prepared',
                        label: 'Not Prepared',
                    },

                    {
                        id: 'needto_prepare',
                        name: 'r1',
                        value: 'Need to Prepare',
                        label: 'Need to Prepare',
                    },
                    {
                        id: 'na',
                        name: 'r1',
                        value: 'NA',
                        label: 'NA',
                    },
                ],
            },

            questionList: [
                {
                    labelName: 'Additional Questions',
                    categoryName: 'Additional',
                    question:
                        '31. How long it will take to reach to the campus?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Additional Questions',
                    categoryName: 'Additional',
                    question: '32. How much do you expect to be earning?',
                    answerType: 'textarea',
                },
            ],
        },
    ];

    financialQuestions: any = [
        {
            primary: {
                heading: 'Financial Questions',
                label: 'Financial Questions',
                categoryName: 'Financial',
                options: [
                    {
                        id: 'prepared',
                        name: 'r1',
                        value: 'Prepared',
                        label: 'Prepared',
                    },
                    {
                        id: 'not_prepared',
                        name: 'r1',
                        value: 'Not Prepared',
                        label: 'Not Prepared',
                    },

                    {
                        id: 'needto_prepare',
                        name: 'r1',
                        value: 'Need to Prepare',
                        label: 'Need to Prepare',
                    },
                    {
                        id: 'na',
                        name: 'r1',
                        value: 'NA',
                        label: 'NA',
                    },
                ],
            },

            questionList: [
                {
                    labelName: 'Financial Questions',
                    categoryName: 'Financial',
                    question:
                        '23. What is your current occupation (if currently employed)?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Financial Questions',
                    categoryName: 'Financial',
                    question: '24. Who is financing your studies?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Financial Questions',
                    categoryName: 'Financial',
                    question:
                        '25. What is the profession of your financial sponsor and what relationship are they to you?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Financial Questions',
                    categoryName: 'Financial',
                    question: '26. What is your parents annual income?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Financial Questions',
                    categoryName: 'Financial',
                    question:
                        '27. In case of UG Student only - How will you fund your remaining years of study and what evidence do you have for same?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Financial Questions',
                    categoryName: 'Financial',
                    question: '28. How many depends does your sponsor has?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Financial Questions',
                    categoryName: 'Financial',
                    question: '29. How are you showing funds for visa?',
                    answerType: 'textarea',
                },
                {
                    labelName: 'Financial Questions',
                    categoryName: 'Financial',
                    question:
                        '30. Will you bring dependents along with you? If yes how will you show funds for them.',
                    answerType: 'textarea',
                },
            ],
        },
    ];
    user_details: any

    constructor(
        private _fb: FormBuilder,
        private _universityService: UniversityService,
        private _authenticationService: AuthenticationService
    ) {}

    ngOnInit(): void {
        this.user_details = this._authenticationService.getLoginUserDetails();
        this._universityService.submitForms.subscribe((res) => {
            if (res) this.onSubmit();
        });
        this.radioQuestionArr =  [
            {
                type: 'radio',
                labelName: 'Common Questions',
                categoryName: 'Common',
                isRequired: true,
                question: 'Is the student giving interview is same as in passport?',
                options: [
                    {
                        id: 'passport_check1',
                        name: 'passport_check',
                        value: 'Answered',
                        label: 'Yes',
                    },
                    {
                        id: 'passport_check2',
                        name: 'passport_check',
                        value: 'Not Answered',
                        label: 'No',
                    },
                    {
                        id: 'passport_check3',
                        name: 'passport_check',
                        value: 'Doubtful',
                        label: 'Doubtful',
                    },
                ],
                subQuestions: [
                    {
                        labelName: 'Doubtful Questions',
                        categoryName: 'Doubtful',
                        id: 'Doubtful',
                        type: 'radio',
                        isRequired: true,
                        question: 'Please confirm your Date of Birth',
                        options: [
                            {
                                id: 'doubt_dob1',
                                name: 'doubt_dob',
                                value: 'Answered',
                                label: 'Answered',
                            },
                            {
                                id: 'doubt_dob2',
                                name: 'doubt_dob',
                                value: 'Not Answered',
                                label: 'Not Answered',
                            },
                        ],
                    },
                    {
                        labelName: 'Doubtful Questions',
                        categoryName: 'Doubtful',
                        id: 'Doubtful',
                        type: 'radio',
                        isRequired: true,
                        question: 'Please tell me your place of birth',
                        options: [
                            {
                                id: 'doubt_dobplace1',
                                name: 'doubt_dobplace',
                                value: 'Answered',
                                label: 'Answered',
                            },
                            {
                                id: 'doubt_dobplace2',
                                name: 'doubt_dobplace',
                                value: 'Not Answered',
                                label: 'Not Answered',
                            },
                        ],
                    },
                    {
                        labelName: 'Doubtful Questions',
                        categoryName: 'Doubtful',
                        id: 'Doubtful',
                        type: 'radio',
                        isRequired: true,
                        question: 'From which school have you studied',
                        options: [
                            {
                                id: 'doubt_school1',
                                name: 'doubt_dobplace',
                                value: 'Answered',
                                label: 'Answered',
                            },
                            {
                                id: 'doubt_school2',
                                name: 'doubt_dobplace',
                                value: 'Not Answered',
                                label: 'Not Answered',
                            },
                        ],
                    },
                    {
                        labelName: 'Doubtful Questions',
                        categoryName: 'Doubtful',
                        id: 'Doubtful',
                        type: 'radio',
                        isRequired: true,
                        question: 'What is your House address',
                        options: [
                            {
                                id: 'doubt_add1',
                                name: 'doubt_add',
                                value: 'Answered',
                                label: 'Answered',
                            },
                            {
                                id: 'doubt_add2',
                                name: 'doubt_add',
                                value: 'Not Answered',
                                label: 'Not Answered',
                            },
                        ],
                    },
                    {
                        labelName: 'Doubtful Questions',
                        categoryName: 'Doubtful',
                        id: 'Doubtful',
                        type: 'radio',
                        isRequired: true,
                        question:
                            'Please confirm me your Email id and phone number',
                        options: [
                            {
                                id: 'doubt_email1',
                                name: 'doubt_email',
                                value: 'Answered',
                                label: 'Answered',
                            },
                            {
                                id: 'doubt_email2',
                                name: 'doubt_email',
                                value: 'Not Answered',
                                label: 'Not Answered',
                            },
                        ],
                    },
                    {
                        labelName: 'Doubtful Questions',
                        categoryName: 'Doubtful',
                        id: 'Doubtful',
                        type: 'radio',
                        isRequired: true,
                        question: "What is your father's and mother's name",
                        options: [
                            {
                                id: 'doubt_mother1',
                                name: 'doubt_mother',
                                value: 'Answered',
                                label: 'Answered',
                            },
                            {
                                id: 'doubt_mother2',
                                name: 'doubt_mother',
                                value: 'Not Answered',
                                label: 'Not Answered',
                            },
                        ],
                    },
                    {
                        labelName: 'Doubtful Questions',
                        categoryName: 'Doubtful',
                        id: 'Doubtful',
                        type: 'radio',
                        isRequired: true,
                        question: 'Please confirm your parents their Date of Birth',
                        options: [
                            {
                                id: 'doubt_fdob1',
                                name: 'doubt_fdob',
                                value: 'Answered',
                                label: 'Answered',
                            },
                            {
                                id: 'doubt_fdob2',
                                name: 'doubt_fdob',
                                value: 'Not Answered',
                                label: 'Not Answered',
                            },
                        ],
                    },
                    {
                        labelName: 'Doubtful Questions',
                        categoryName: 'Doubtful',
                        id: 'Doubtful',
                        type: 'radio',
                        isRequired: true,
                        question: "What is your grandparent's name",
                        options: [
                            {
                                id: 'doubt_grandn1',
                                name: 'doubt_grandn',
                                value: 'Answered',
                                label: 'Answered',
                            },
                            {
                                id: 'doubt_grandn2',
                                name: 'doubt_grandn',
                                value: 'Not Answered',
                                label: 'Not Answered',
                            },
                        ],
                    },
                    {
                        labelName: 'Doubtful Questions',
                        categoryName: 'Doubtful',
                        id: 'Doubtful',
                        type: 'radio',
                        isRequired: true,
                        question: 'Please do a signature same as to your passport',
                        options: [
                            {
                                id: 'doubt_sign1',
                                name: 'doubt_sign',
                                value: 'Answered',
                                label: 'Answered',
                            },
                            {
                                id: 'doubt_sign2',
                                name: 'doubt_sign',
                                value: 'Not Answered',
                                label: 'Not Answered',
                            },
                        ],
                    },
                ],
                subQuestionLabel: {
                    label: 'Doubtful Questions',
                    categoryName: 'Doubtful',
                },
            },
            {
                labelName: 'Common Questions',
                categoryName: 'Common',
                type: 'radio',
                isRequired: true,
                question:
                    'The interview will take approximately 30 minutes. Are you feeling fit and well enough to be interviewed today?',
                options: [
                    {
                        id: 'interview_ans1',
                        name: 'interview_ans',
                        value: 'Answered',
                        label: 'Answered',
                    },
                    {
                        id: 'interview_ans2',
                        name: 'interview_ans',
                        value: 'Not Answered',
                        label: 'Not Answered',
                    },
                ],
            },
            {
                labelName: 'Common Questions',
                categoryName: 'Common',
                type: 'radio',
                isRequired: true,
                question:
                    'Can you hear me clearly and understand what I am saying?',
                options: [
                    {
                        id: 'hear_me1',
                        name: 'interview_ans',
                        value: 'Answered',
                        label: 'Answered',
                    },
                    {
                        id: 'hear_me2',
                        name: 'interview_ans',
                        value: 'Not Answered',
                        label: 'Not Answered',
                    },
                ],
            },
            {
                labelName: 'Common Questions',
                categoryName: 'Common',
                type: 'radio',
                isRequired: true,
                question:
                    'Please can you tell me your full name and date of birth?',
                options: [
                    {
                        id: 'birth_ans1',
                        name: 'interview_ans',
                        value: 'Answered',
                        label: 'Answered',
                    },
                    {
                        id: 'birth_ans2',
                        name: 'interview_ans',
                        value: 'Not Answered',
                        label: 'Not Answered',
                    },
                ],
            },
            {
                labelName: 'Common Questions',
                categoryName: 'Common',
                type: 'radio',
                isRequired: true,
                question:
                    'Which course have you applied to study at '+ this.uniName +'?',
                options: [
                    {
                        id: 'appliedstudy_ans1',
                        name: 'interview_ans',
                        value: 'Answered',
                        label: 'Answered',
                    },
                    {
                        id: 'appliedstudy_ans2',
                        name: 'interview_ans',
                        value: 'Not Answered',
                        label: 'Not Answered',
                    },
                ],
            },
            {
                labelName: 'Common Questions',
                categoryName: 'Common',
                type: 'radio',
                isRequired: true,
                question:
                    'I am going to be typing my questions and your answers down therefore I need you to speak slowly and clearly for me. If at any point you are speaking too fast, I will ask you to stop slow down and repeat what you just said. Is this okay?',
                options: [
                    {
                        id: 'type_qus1',
                        name: 'interview_ans',
                        value: 'Answered',
                        label: 'Answered',
                    },
                    {
                        id: 'type_qus2',
                        name: 'interview_ans',
                        value: 'Not Answered',
                        label: 'Not Answered',
                    },
                ],
            },
        ];
        this.interviewForm = this._fb.group({
            radioQuestions: this._fb.array([]),
            decisionQuestions: this._fb.array([]),
            compulsoryQuestions: this._fb.array([]),
            financialQuestions: this._fb.array([]),
            additionalQuestions: this._fb.array([]),
            livingExpenseQuestions: this._fb.array([]),
        });

        this.initRadioQuestions();
        this.initCompulsoryQuestions();
        this.initFinancialQuestions();
        this.initAdditionalQuestions();
        this.initLivingExpenseQuestions();
        console.log(this.uniName);
        
    }

    initRadioQuestions() {
        const control = this.interviewForm.get('radioQuestions') as FormArray;
        const decisionControl = this.interviewForm.get(
            'decisionQuestions'
        ) as FormArray;
        this.radioQuestionArr.forEach((q, index) => {
            const group = this._fb.group({
                question: [q.question],
                answer: [
                    this.questions?.radioData[index]?.answer || '',
                    Validators.required,
                ],
                subQuestions: this._fb.array([]),
            });
            control.push(group);
            if (
                this.questions?.radioData[index]?.subQuestions &&
                this.questions?.radioData[index]?.subQuestions.length > 0
            ) {
                this.onChanges(
                    group,
                    index,
                    this.questions?.radioData[index]?.subQuestions
                );
            }
        });
        this.decisionQuestionArr[0]?.questions.forEach((q, index) => {
            const group = this._fb.group({
                question: [q.question],
                answer: [
                    this.questions?.decisionRadioData[index].answer || '',
                    Validators.required,
                ],
            });
            decisionControl.push(group);
        });
    }

    onChanges(control: any, index: number = 0, subQuestions: any = {}): void {
        this.updateSubQuestions(control, index, subQuestions);
    }

    updateSubQuestions(
        control: FormGroup,
        index: number = 0,
        subQuestions: any = {}
    ) {
        const question = this.radioQuestionArr[index];
        const answer = control.get('answer').value;

        if (question.subQuestions) {
            const subControl = control.get('subQuestions') as FormArray;
            subControl.clear();

            if (question.options) {
                question.subQuestions
                    .filter((item) => item.id === answer)
                    .forEach((subQ, subIndex) => {
                        const subGroup = this._fb.group({
                            question: [subQ.question],
                            answer: [subQuestions[subIndex]?.answer || ''],
                        });
                        subControl.push(subGroup);
                    });
            }
        }
    }

    initAdditionalQuestions() {
        const control = <FormArray>(
            this.interviewForm.get('additionalQuestions')
        );
        this.additionalQuestions.forEach((q) => {
            const group = this._fb.group({
                additionalQuestionList: this._fb.array(
                    q.questionList.map((item, index) =>
                        this._fb.group({
                            question: [item.question],
                            answer: [
                                this.questions?.additionalQuestions[index]
                                    ?.answer || '',
                            ],
                            preparation: [
                                this.questions?.additionalQuestions[index]
                                    ?.preparation || '',
                            ],
                        })
                    )
                ),
            });
            control.push(group);
        });
    }

    initLivingExpenseQuestions() {
        const control = <FormArray>(
            this.interviewForm.get('livingExpenseQuestions')
        );
        this.livingExpenseQuestions.forEach((q) => {
            const group = this._fb.group({
                livingQuestionList: this._fb.array(
                    q.questionList.map((item, index) =>
                        this._fb.group({
                            question: [item.question],
                            answer: [
                                this.questions?.livingExpenseQuestions[index]
                                    ?.answer || '',
                            ],
                            preparation: [
                                this.questions?.livingExpenseQuestions[index]
                                    ?.preparation || '',
                            ],
                        })
                    )
                ),
            });
            control.push(group);
        });
    }

    initFinancialQuestions() {
        const control = <FormArray>this.interviewForm.get('financialQuestions');
        this.financialQuestions.forEach((q) => {
            const group = this._fb.group({
                financialQuestionList: this._fb.array(
                    q.questionList.map((item, index) =>
                        this._fb.group({
                            question: [item.question],
                            answer: [
                                this.questions?.financialQuestions[index]
                                    ?.answer || '',
                            ],
                            preparation: [
                                this.questions?.financialQuestions[index]
                                    ?.preparation || '',
                            ],
                        })
                    )
                ),
            });
            control.push(group);
        });
    }

    initCompulsoryQuestions() {
        const control = <FormArray>(
            this.interviewForm.get('compulsoryQuestions')
        );
        this.interviewQuestions.forEach((q) => {
            const group = this._fb.group({
                questionList: this._fb.array(
                    q.questionList.map((item, index) =>
                        this._fb.group({
                            question: [item.question],
                            answer: [
                                this.questions?.compulsoryQuestionList[index]
                                    ?.answer || '',
                            ],
                            preparation: [
                                this.questions?.compulsoryQuestionList[index]
                                    ?.preparation || '',
                            ],
                        })
                    )
                ),
            });
            control.push(group);
        });
    }

    onSubmit() {
        const radioData = this.interviewForm?.value?.radioQuestions.map(
            (element, index) => {
                return {
                    labelName: this.radioQuestionArr[index]?.labelName,
                    question: this.radioQuestionArr[index]?.question,
                    answer: element?.answer,
                    answerType: this.radioQuestionArr[index]?.type,
                    asnwerValues: this.radioQuestionArr[index]?.options.map(
                        (item) => {
                            return {
                                id: item?.id,
                                values: item?.label,
                            };
                        }
                    ),
                    categoryName: this.radioQuestionArr[index]?.categoryName,
                    optionalFields: [],
                    subQuestions: this.radioQuestionArr[
                        index
                    ]?.subQuestions?.map((item, subIndex) => {
                        return {
                            labelName:
                                this.radioQuestionArr[index]?.subQuestionLabel
                                    ?.label,
                            questions: item?.question,
                            categoryName: item?.categoryName,
                            answer: element.subQuestions[subIndex]?.answer,
                            answerType: item?.type,
                            answerValues: item.options.map((item) => {
                                return {
                                    id: item?.id,
                                    values: item?.label,
                                };
                            }),
                            optionalFields: [],
                        };
                    }),
                };
            }
        );

        const decisionRadioData =
            this.interviewForm?.value?.decisionQuestions.map(
                (element, index) => {
                    return {
                        labelName:
                            this.decisionQuestionArr[0]?.questions[index]
                                ?.labelName,
                        question:
                            this.decisionQuestionArr[0]?.questions[index]
                                ?.question,
                        answer: element?.answer,
                        answerType:
                            this.decisionQuestionArr[0]?.questions[index]?.type,
                        asnwerValues: this.decisionQuestionArr[0]?.questions[
                            index
                        ].options.map((item) => {
                            return {
                                id: item?.id,
                                values: item?.label,
                            };
                        }),
                        categoryName:
                            this.decisionQuestionArr[0]?.questions[index]
                                .categoryName,
                        optionalFields: [],
                        subQuestions: [],
                    };
                }
            );

        const compulsoryQuestionList =
            this.interviewForm?.value?.compulsoryQuestions[0].questionList.map(
                (element, index) => {
                    return {
                        labelName:
                            this.interviewQuestions[0]?.questionList[index]
                                ?.labelName,
                        question:
                            this.interviewQuestions[0]?.questionList[index]
                                ?.question,
                        answer: element?.answer,
                        preparation: element?.preparation,
                        answerType:
                            this.interviewQuestions[0]?.questionList[index]
                                ?.answerType,
                        answerValues:
                            this.interviewQuestions[0]?.primary?.options.map(
                                (item) => {
                                    return {
                                        id: item?.value,
                                        values: item?.value,
                                    };
                                }
                            ),
                        categoryName:
                            this.interviewQuestions[0]?.questionList[index]
                                ?.categoryName,
                        optionalFields: [],
                        subQuestions: [],
                    };
                }
            );

        const additionalQuestions =
            this.interviewForm?.value?.additionalQuestions[0].additionalQuestionList.map(
                (element, index) => {
                    return {
                        labelName:
                            this.additionalQuestions[0]?.questionList[index]
                                ?.labelName,
                        question:
                            this.additionalQuestions[0]?.questionList[index]
                                ?.question,
                        answer: element?.answer,
                        preparation: element?.preparation,
                        answerType:
                            this.additionalQuestions[0]?.questionList[index]
                                ?.answerType,
                        answerValues:
                            this.interviewQuestions[0]?.primary?.options.map(
                                (item) => {
                                    return {
                                        id: item?.value,
                                        values: item?.value,
                                    };
                                }
                            ),
                        categoryName:
                            this.additionalQuestions[0]?.questionList[index]
                                ?.categoryName,
                        optionalFields: [],
                        subQuestions: [],
                    };
                }
            );

        const financialQuestions =
            this.interviewForm?.value?.financialQuestions[0].financialQuestionList.map(
                (element, index) => {
                    return {
                        labelName:
                            this.financialQuestions[0]?.questionList[index]
                                ?.labelName,
                        question:
                            this.financialQuestions[0]?.questionList[index]
                                ?.question,
                        answer: element?.answer,
                        preparation: element?.preparation,
                        answerType:
                            this.financialQuestions[0]?.questionList[index]
                                ?.answerType,
                        answerValues:
                            this.interviewQuestions[0]?.primary?.options.map(
                                (item) => {
                                    return {
                                        id: item?.value,
                                        values: item?.value,
                                    };
                                }
                            ),
                        categoryName:
                            this.financialQuestions[0]?.questionList[index]
                                ?.categoryName,
                        optionalFields: [],
                        subQuestions: [],
                    };
                }
            );
        const livingExpenseQuestions =
            this.interviewForm?.value?.livingExpenseQuestions[0].livingQuestionList.map(
                (element, index) => {
                    return {
                        labelName:
                            this.livingExpenseQuestions[0]?.questionList[index]
                                ?.labelName,
                        question:
                            this.livingExpenseQuestions[0]?.questionList[index]
                                ?.question,
                        answer: element?.answer,
                        preparation: element?.preparation,
                        answerType:
                            this.livingExpenseQuestions[0]?.questionList[index]
                                ?.answerType,
                        answerValues:
                            this.livingExpenseQuestions[0]?.primary?.options.map(
                                (item) => {
                                    return {
                                        id: item?.value,
                                        values: item?.value,
                                    };
                                }
                            ),
                        categoryName:
                            this.livingExpenseQuestions[0]?.questionList[index]
                                ?.categoryName,
                        optionalFields: [],
                        subQuestions: [],
                    };
                }
            );

        // const questions = [
        //     ...radioData,
        //     ...compulsoryQuestionList,
        //     ...decisionRadioData,
        //     ...additionalQuestions,
        //     ...financialQuestions,
        //     ...livingExpenseQuestions,
        // ];
        const questions = {
            radioData,
            compulsoryQuestionList,
            decisionRadioData,
            additionalQuestions,
            financialQuestions,
            livingExpenseQuestions,
        };

        this.formSubmit.emit({
            questions,
        });
    }
}
